import "./index.css";
import type { ReactNode } from "react";
import { clsx } from "clsx";

type IProps = {
  className?: string;
  children: ReactNode;
};

export const CardContent = ({ className, children }: IProps) => {
  const rootClass = clsx("nuco-card-content", className);

  return <div className={rootClass}>{children}</div>;
};
